import './css.js';

async function init() {
    await import('../../assets/unify/plugins/back-to-top.js');
    await import('../../assets/unify/plugins/owl-carousel/owl-carousel/owl.carousel.js');
    const moment = await import('moment');
    const login = await import('../../assets/custom/js/user/login.js');
    const OwlCarousel = await import(/* webpackChunkName: "owlCarousel" */ '../../assets/unify/js/plugins/owl-carousel.js');
    $(document).ready(function() {
        OwlCarousel.initOwlCarousel();
    });

    $('.readmore').click(function (event) {
        var that$ = $(this);
        that$.closest('div.text-content').find('div.texthide').removeClass('texthide').addClass('showmore').end().find('div.overtext').remove();
        that$.remove();
    });

    let moreListPanels$ = $('.panel-collapse');
    moreListPanels$.on('shown.bs.collapse', function () {
        let toggleButton = $('div.morelist[href="#' + this.id + '"]');
        if (typeof toggleButton.get(0).scrollIntoView === 'function') {
            toggleButton.get(0).scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
        toggleButton.trigger('changeMoreListText');
    });
    moreListPanels$.on('hidden.bs.collapse', function () {
        let toggleButton = $('div.morelist[href="#' + this.id + '"]');
        toggleButton.trigger('changeMoreListText');
    });

    $('.morelist').on('changeMoreListText', function () {
        let collapse = $(this).attr('href');
        let collapse$ = $(collapse);
        let isOpen = collapse$.hasClass('in');

        if (isOpen === true) {
            $(this).find('.show-promotion-list').hide();
            $(this).find('.hidden-promotion-list').show();
        } else {
            $(this).find('.hidden-promotion-list').hide();
            $(this).find('.show-promotion-list').show();
        }
    });

    $(async function () {
        let text = await import('../../public/locales/'+locale+'/hotel.json');
        $('#select-promotion-group').change(function (event) {
            var that$ = $(this);
            var groupNo = that$.val();
            $('#change-promotion-group-loading').removeClass('hide');
            if (groupNo != 0) {
                window.location = urlPrefix + '/' +hotelId + '/promotion/list/' + groupNo;
            } else {
                window.location = urlPrefix + '/' +hotelId + '/promotion/list';
            }
        });

        $('#select-promoCode-group').change(function (event) {
            var that$ = $(this);
            var promoCode = that$.val().split("-");

            $('#change-promotion-group-loading').removeClass('hide');
            if (promoCode[1] != 0) {
                window.location = urlPrefix + '/' + hotelId + '/promocode/' + promoCode[0] + '/' + promoCode[1];
            } else {
                window.location = urlPrefix + '/' + hotelId + '/promocode/' + promoCode[0] ;
            }
        });

        $('#select-ticket-group').change(function (event) {
            var that$ = $(this);
            var groupNo = that$.val();

            $('#change-promotion-group-loading').removeClass('hide');
            if (groupNo != 0) {
                window.location = urlPrefix + '/' +hotelId + '/ticket/list/' + groupNo;
            } else {
                window.location = urlPrefix + '/' +hotelId + '/ticket/list';
            }
        });

        function fetchInventory(cb) {
            var that = this;
            that.isLoading = true;
            that.checkInDate = '';
            $.ajax(urlPrefix + '/promotion/inventory/' + promotionNo, {
                type: 'POST',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                data: {
                    'start-date': that.startDay.format('YYYY-MM-DD'),
                    'end-date': that.endDay.format('YYYY-MM-DD'),
                    'room-qty': that.roomQty,
                    'nights': that.nights,
                    'is-channel': that.isChannel
                },
                dataType: 'json',
                success: function(res) {
                    if (true === res.status) {
                        if (true === res.waiting) {
                            that.waiting_on = res.waiting;
                        }
                        var row = that.calendarRow;
                        var inventory = [];
                        var inventoryWeek;
                        for (var i = 0; i <= row; i++) {
                            inventoryWeek = [];
                            for (var j = (7*i); j < (7*(i+1)); j++) {
                                if(j < that.calendar.firstDateDay) {
                                    inventoryWeek.push({
                                        current: false
                                    });
                                } else if (j - that.calendar.firstDateDay >= that.calendar.endDate) {
                                    inventoryWeek.push({
                                        current: false
                                    });
                                } else {
                                    inventoryWeek.push({
                                        date: moment(res.inventory[j - that.calendar.firstDateDay].date),
                                        price: res.inventory[j - that.calendar.firstDateDay].price,
                                        qty: res.inventory[j - that.calendar.firstDateDay].qty,
                                        available: res.inventory[j - that.calendar.firstDateDay].available,
                                        applicable: res.inventory[j - that.calendar.firstDateDay].applicable,
                                        isAfter: moment(res.inventory[j - that.calendar.firstDateDay].date).isSameOrAfter(moment().format('YYYY-MM-DD'), 'day'),
                                        current: true
                                    });
                                }
                            }
                            inventory.push(inventoryWeek);
                        }
                        that.inventory = inventory;
                    } else {
                        alert(res.message);
                        cb();
                    }
                    that.isLoading = false;
                }
            });
        }

        if (document.getElementById('vue-promotion') !== null) {
            let today = moment();
            let calendarInitDate = today.isBefore(moment(startDay))? moment(startDay) : today;

            let vm = new Vue({
                el: '#vue-promotion',
                data: {
                    nights: nights,
                    isChannel: isChannel,
                    roomQty: 1,
                    calendar: {
                        today: today,
                        year: calendarInitDate.year(),
                        month: calendarInitDate.month() + 1,
                        firstDateDay: calendarInitDate.startOf('month').day(),
                        endDate: calendarInitDate.endOf('month').date()
                    },
                    waiting_on: false,
                    inventory: [],
                    checkInDate: '',
                    isWaiting: 0,
                    isLoading: false,
                    nextLoading: false
                },
                created: function () {
                    // 先抓取第一個月份的庫存
                    fetchInventory.call(this);
                },
                computed: {
                    startDay: function() {
                        var calendarStart = moment(startDay);
                        if (calendarStart.isSame(moment([this.calendar.year, this.calendar.month - 1]), 'month')){
                            return calendarStart;
                        } else {
                            return moment([this.calendar.year, this.calendar.month - 1]).startOf('month');
                        }
                    },
                    endDay: function() {
                        var calendarEnd = moment(endDay);
                        if (calendarEnd.isSame(moment([this.calendar.year, this.calendar.month - 1]), 'month')){
                            return calendarEnd;
                        } else {
                            return moment([this.calendar.year, this.calendar.month - 1]).endOf('month');
                        }
                    },
                    calendarRow: function() {
                        return Math.ceil((this.calendar.endDate + this.calendar.firstDateDay) / 7) - 1;
                    },
                    currentMonth: function() {
                        return this.calendar.today.isSame(moment([this.calendar.year, this.calendar.month - 1]), 'month');
                    },
                    checkInDateSend: function() {
                        if (this.checkInDate instanceof moment) {
                            return this.checkInDate.format('YYYY-MM-DD');
                        }
                        return '';
                    }
                },
                methods: {
                    prev: function () {
                        var changeDate = moment([this.calendar.year, this.calendar.month - 1])
                            .subtract(1, 'months');
                        if (changeDate.isSameOrAfter(moment().format('YYYY-MM-DD'), 'month')) {
                            this.calendar.year = changeDate.year();
                            this.calendar.month = changeDate.month() + 1;
                            this.calendar.firstDateDay = changeDate.startOf('month').day();
                            this.calendar.endDate = changeDate.endOf('month').date();
                            fetchInventory.call(this, this.next);
                        } else {
                            alert(text.SystemText.NotFurther);
                        }
                    },
                    next: function () {
                        var changeDate = moment([this.calendar.year, this.calendar.month - 1])
                            .add(1, 'months');
                        this.calendar.year = changeDate.year();
                        this.calendar.month = changeDate.month() + 1;
                        this.calendar.firstDateDay = changeDate.startOf('month').day();
                        this.calendar.endDate = changeDate.endOf('month').date();
                        fetchInventory.call(this, this.prev);
                    },
                    selectRoomQty: function () {
                        this.checkInDate = '';
                        fetchInventory.call(this, function(){});
                    },
                    selectNights: function () {
                        this.checkInDate = '';
                        fetchInventory.call(this, function(){});
                    },
                    selectCheckInDate: function (date, isWaiting, event) {
                        var this$ = $(event.target).closest('a');
                        this$.focus();
                        this.checkInDate = date;
                        this.isWaiting = isWaiting || 0;
                    },
                    backList: function () {
                        window.location = urlPrefix + '/promotion/list';
                    },
                    submitNext: function(event) {
                        var that = this;
                        if (that.checkInDate instanceof moment) {
                            that.nextLoading = true;
                            let form$ = $('#promotion-submit-form');
                            login.check(function (err, status, userInfo) {
                                if (status === true) {
                                    form$.submit();
                                } else {
                                    if(enableMember === true){
                                        that.nextLoading = false;
                                        login.initModal($(event.target), function(target){
                                            that.nextLoading = true;
                                            form$.submit();
                                        }, !!that.isWaiting);
                                    }else{
                                        form$.submit();
                                    }
                                }
                            });
                        } else {
                            alert(text.SystemText.SelectDate);
                        }
                    }
                }
            });
        }
    });

    // 2022-12-02 國軍英雄館套裝訂房增加公告
    $(document).ready(function () {
        $('#autoNotice').get(0).click();
    });

    $('#Notice-remember').on('change', function () {
        $.ajax(urlPrefix + '/api/index/notice', {
            type: 'post',
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr('content')
            }
        });
    })
}

init();


// WEBPACK FOOTER //
// ./webpack/promotion/entry.js